angular.module("ainapp")
    .controller("AccountLoadingController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Voucher Accounts Loading";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.AccountTypes = [];
            MainService.AccountTypesInDropdown().then(function (response) {
                $scope.AccountTypes = response.data;
            });


            $scope.Init = function () {

                $scope.load = false;
                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                })


                $scope.ViewVal = 0;
                $scope.ViewValType = 'Material Request';

                $scope.CostSetting = {
                    VoucherType: "Material Request",
                    LoadType: "",
                    AccountTypeId: ""
                }

                $scope.CostCenterSettings = [];
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AccountLoadingbyType("Material Request").then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.switchTab = function (tab, type) {
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.CostCenterSettings = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.AccountLoadingbyType(type).then(function (response) {
                    $scope.CostCenterSettings = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })
                $scope.refreshCostCenter();

            }

            $scope.refreshCostCenter = function () {

                $scope.CostSetting = {
                    VoucherType: $scope.ViewValType,
                    LoadType: "",
                    AccountTypeId: ""
                }

            }

            $scope.editCostCenter = function (data) {

                $scope.CostSetting = data;

            }

            $scope.saveCostSettings = function () {

                if ($scope.CostSetting.AccountTypeId == "") {
                    toastr.warning("Choose Account Type");
                } else if ($scope.CostSetting.LoadType == "") {
                    toastr.warning("Choose Load Type");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.CostSetting.VoucherName = $scope.ViewValType;
                    MainService.AddAccountLoading($scope.CostSetting).then(function (response) {
                        if (response.data) {
                            toastr.success("Success");
                            $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                            $scope.refreshCostCenter();
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                        $scope.load = false;
                    })
                }

            }

            $scope.deleteSet = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteAccountLoading(data.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                        $scope.refreshCostCenter();
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }


            $scope.loadall = function () {

                if ($scope.CostSetting.LoadType == "") {
                    toastr.warning("Select Load Type");
                } else {
                    var int = 0;
                    angular.forEach($scope.AccountTypes, function (e) {

                        var CostSetting = {
                            VoucherName: $scope.ViewValType,
                            LoadType: $scope.CostSetting.LoadType,
                            AccountTypeId: e.Id,
                        }

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.AddAccountLoading(CostSetting).then(function (response) {
                            if (response.data) {

                                int = int + 1;
                                if (int == $scope.AccountTypes.length) {
                                    toastr.success("Success");
                                    $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                                    $scope.refreshCostCenter();
                                }

                            } else {
                                toastr.error("Network Error");
                            }
                            $scope.load = false;
                            $.LoadingOverlay("hide");
                        }, function (err) {
                            $.LoadingOverlay("hide");
                            toastr.error("Network Error");
                            $scope.load = false;
                        })

                    })
                }


            }




      }]);
